import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import dayjs from 'dayjs';

import React, { useContext, useEffect, useRef, useState } from 'react'
import systemConfig from '../../../../config/systematic';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from '../../../universal/getList';
import antMessage from '../../../../utils/extend/AntdNotification'
import entrepotPrint from '../../../../generalMethod/entrepotPrint';
import 'dayjs/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import DownloadExcel from '../../../report/DownloadExcel';
import { SocketContext } from '../../../../App';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
// import { createStyles } from 'antd-style';
const { RangePicker } = DatePicker;
export default function ExDailyReport() {

  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm()
  const [deptData, setDeptData] = useState<any>();
  const contentRef = useRef<any>(null);
  const [buyerData, setBuyerData] = useState<any>()

  const [queryCriteria, setQueryCriteria] = useState<any>("")
  const notificationApi = useNotificationInstance()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [columnsHead, setColumnsHead] = useState<Array<any>>([])
  // 
  const [rows, setRows] = useState<any>([]);
  const useContextData = useContext(SocketContext);
  const { contextData, setContextData } = useContextData;
  const [warehouseCategoriesData, setWarehouseCategoriesData] = useState<any>([])
  const initialValues: any = {
    chooseTime: [dayjs(), dayjs()],
    isBuyerDetail: true,
    dataStatusType: 1
  };

  const [dataTypeData, setDataTypeData] = useState<Array<any>>();

  useEffect(() => {

    const fetchData = async () => {
      form.setFieldValue("chooseTime", [dayjs(), dayjs()])
      let deptData = await fetchApi.GET(wmService, {
        apiId: "dept",
        apiExtend: 'showList',
        apiData: {

        }
      })
      if (deptData.success) {
        setDeptData(deptData.data)
      }

      let buyerData = await fetchApi.GET(wmService, {
        apiId: "buyer",
        apiExtend: 'showList'
      })
      if (buyerData.success) {

        setBuyerData(buyerData.data)
      }
      // warehouseCategories
      let warehouseCategoriesData = await fetchApi.GET(wmService, {
        apiId: "warehouseCategories",
        apiExtend: 'showList'
      })


      if (warehouseCategoriesData.success) {

        setWarehouseCategoriesData(warehouseCategoriesData.data)
      }
      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {


        fetchApi.GET(wmService, {
          apiId: "entrepotReport",
          apiExtend: 'purDailyReport',
          apiData: {
            ...values,
            entrepotId: contextData?.currentEntrepotId,

            time: values.chooseTime ? {
              startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
            } : null,

            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,
            mountDataOptions: {
              userMount: {
                isEmployees: true,
                isDept: true,
                isUserAreas: true
              }
            },
          }
        }).then((res: any) => {
          setIsLoading(false)
          setRows(res.data.rows)
          setColumnsHead(res.data.columns)
          setQueryCriteria(res.data.queryCriteria)
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });

        }).catch((err: any) => {
          console.log("err", err);
          setIsLoading(false)
          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
        })
      })
      .catch((err) => {
        setIsLoading(false)
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;
      })
  }


  // 修改后的 handlePrint 配置
  const handlePrint = () => {
    if (rows.length === 0) {
      antMessage('error', '打印失败', "无打印数据");
      return false
    }
    let table = document.getElementsByTagName("table")[0]
    table.border = "1";
    table.style.width = "100%";
    table.cellPadding = "0";
    table.cellSpacing = "0";
    let data = document.getElementById("aa")?.innerHTML;
    entrepotPrint.printEnReportEx(JSON.stringify(data), "exDailyReport")
  }
  const footer = (data: any) => {
    return <div style={{ display: "flex", justifyContent: 'space-between' }}>
      <div>日期:{moment(queryCriteria.startTime).format("YYYY-MM-DD")}~{moment(queryCriteria.endTime).format("YYYY-MM-DD")}</div>
      <div>制表人:{queryCriteria.userName}</div>

    </div>
  }
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Row>

          <Col span={5}>
            <Form.Item
              label="大类"
              name="warehouseCategoriesIds"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="大类"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(warehouseCategoriesData, 'warehouseCategoriesName')}
              </Select>
            </Form.Item>
          </Col>



          <Col span={3}>
            <Form.Item
              label="品号"
              name="selfStart"
            >
              <Input

              />
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              colon={false}
              label="-"
              name="selfEnd"
            >
              <Input
              // onChange={handleChange}
              // onBlur={handleBlur}
              // placeholder="Input a number"
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="日期"
              name="chooseTime"

            >
              <RangePicker
                locale={locale}
                defaultValue={initialValues.chooseTime}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>
          {/* <Col span={1.5}>
            <Form.Item
              label="当前分店"
              name="isCurrentBranchStore"
              valuePropName="checked"

            >
              <Checkbox onChange={onChangeBranchStore}></Checkbox>
            </Form.Item>
          </Col> */}

          <Col span={4}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                {/* <Button onClick={() => DownloadExcel(rows, "purDailyReport", { columnsHead, ...queryCriteria })}>下载EXCEL文件</Button> */}
                <Button onClick={handlePrint}>打印</Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>



      {/* <Button onClick={() => DownloadExcel(rows, "moonReport",queryCriteria)}>下载EXCEL文件</Button> */}

      <div id='aa' ref={contentRef}>
        <div style={{ fontSize: 20, textAlign: "center", marginBottom: 10 }}>进货日报表</div>
        <Table
          footer={footer}
          // className='asdsada'
          pagination={false}
          bordered
          rowKey={(record: any) => record.id}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>
      </div>
    </>
  )
}
export let handleData = (rows: any, objKey: string) => {
  let newArr: Array<any> = []

  if (typeof rows === "undefined") return newArr

  for (var i = 0; i < rows.length; i++) {
    newArr.push({
      [objKey]: rows[i]
    })
  }

  return newArr
}